import { Middleware, MiddlewareNext } from '@/router/middlewares/types';
import { Route } from 'vue-router';
import Utils from '@/utils/Utils';

// Check IE browser and redirect it to unsupported page.
export const ValidateBrowserMiddleware: Middleware = {
  handle(to: Route, _from: Route, next: MiddlewareNext, _data?: any) {
    const isIEBrowser = Utils.detectIE();
    // Check if rerequest needs to unsupprted-warning to avoid recurssion
    if (to.name === 'unsupported-warning' && isIEBrowser) {
      return next();
    }

    if (isIEBrowser) {
      return next({ name: 'unsupported-warning' });
    }

    if (to.name === 'unsupported-warning' && !isIEBrowser) {
      return next({ name: 'auth.login' });
    }
  }
};
